import React from 'react';

import './styles.scss';

export default function Tags({ children }) {
  return <ul className="tags">{children}</ul>;
}

export function Tag({ children }) {
  return <li className="tag">{children}</li>;
}
